var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.91732 10.0003C2.91732 6.54855 5.71554 3.75033 9.16732 3.75033C12.6191 3.75033 15.4173 6.54855 15.4173 10.0003L15.4173 11.4941L13.6288 9.70564C13.4661 9.54292 13.2023 9.54292 13.0396 9.70564C12.8768 9.86836 12.8768 10.1322 13.0396 10.2949L15.5396 12.7949C15.7023 12.9576 15.9661 12.9576 16.1288 12.7949L18.6288 10.2949C18.7915 10.1322 18.7915 9.86836 18.6288 9.70564C18.4661 9.54292 18.2023 9.54292 18.0396 9.70564L16.2507 11.4946L16.2507 10.0003C16.2507 6.08831 13.0793 2.91699 9.16732 2.91699C5.2553 2.91699 2.08398 6.08831 2.08398 10.0003C2.08398 13.9123 5.2553 17.0837 9.16732 17.0837C9.39743 17.0837 9.58398 16.8971 9.58398 16.667C9.58398 16.4369 9.39743 16.2503 9.16732 16.2503C5.71554 16.2503 2.91732 13.4521 2.91732 10.0003Z",
    fill: "#A8A7CC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlip);
export default __webpack_public_path__ + "static/media/flip.a7ed045a45f251d021111f2a4b588209.svg";
export { ForwardRef as ReactComponent };